import HeaderLessons from './HeaderLessons';
import { Outlet } from 'react-router-dom';

export default function LessonsLayout() {
  return (
    <>
      <HeaderLessons />   {/* rămâne montat */}
      <Outlet />          {/* aici se schimbă paginile */}
    </>
  );
}
